<div style="padding-bottom:45px;">
  <app-bread-crumbs *ngIf="!isLoading" [activePage]="activePage"
    (buttonActionHandler)="breadcrumbsButtonActionHandler($event)">
  </app-bread-crumbs>
</div>

<div *ngIf="isDownloading" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container rfq-summary-report-page">
  <app-layout class="container--form">
    <shared-alert [type]="alertType.Error" *ngIf="downloadErrorMessage">
      <p alert-content class="my-2 paragraph-small-regular" [innerHTML]="downloadErrorMessage"></p>
    </shared-alert>
    <app-loader [isLoading]="isLoading"></app-loader>
    <form [formGroup]="filtersForm" *ngIf="!isLoading">
      <div class="section--filter mt-3">
        <mat-expansion-panel expanded="true" togglePosition="before">
          <mat-expansion-panel-header>
            <mat-panel-title>Filter</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="container pt-3">
            <div class="d-flex row">
              <div class="form-field col-4">
                <p class="mb-1 paragraph-medium-regular"> RFQ Summary document no. </p>
                <mat-form-field *ngIf="RFQSummaryNumItem.length <= 1" class="custom-form-field--text"
                  [ngClass]="{'has-error': filtersForm.get('RFQSummaryNumber')?.hasError(ValidationError.INVALID_RFQ_Summary_DOCUMENT_NUMBER)}">
                  <input matInput formControlName="RFQSummaryNumber" placeholder="Filter by RFQ Summary number"
                    (blur)="onRFQSummaryNumBlur($event)">
                  <button class="clear-button" *ngIf="filtersForm.get('RFQSummaryNumber')?.value" matSuffix
                    mat-icon-button aria-label="Clear" (click)="onRFQSummaryNumClear()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
                <ng-select *ngIf="RFQSummaryNumItem.length > 1" class="custom-ng-select--multiple "
                  [items]="RFQSummaryNumItem" bindLabel="value" bindValue="id" groupBy="groupBy" [multiple]="true"
                  [closeOnSelect]="false" [selectableGroup]="true" [selectableGroupAsModel]="false" appearance="outline"
                  formControlName="RFQSummaryNumber" [placeholder]="selectedRFQSummaryNumberLabel">
                  <ng-template ng-label-tmp let-item="item" let-index="index">
                  </ng-template>
                  <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                    <mat-checkbox [checked]="isEveryRFQSummaryNumChecked"
                      [indeterminate]="!isEveryRFQSummaryNumChecked && filtersForm.get('RFQSummaryNumber')!.value.length !== 0"
                      color="primary">Select
                      All</mat-checkbox>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <mat-checkbox [checked]="filtersForm.get('RFQSummaryNumber')!.value.includes(item.id)"
                      color="primary">{{item.value}}</mat-checkbox>
                  </ng-template>
                </ng-select>
                <p class="form-field- paragraph-small-regular"
                  *ngIf="filtersForm.get('RFQSummaryNumber')?.hasError(ValidationError.INVALID_RFQ_Summary_DOCUMENT_NUMBER)">
                  Fill in a valid RFQ Summary document number
                </p>
              </div>
              <div class="form-field col-4">
                <p class="mb-1 paragraph-medium-regular"> MP document no. </p>
                <mat-form-field class="custom-form-field--text"
                  [ngClass]="{'has-error': filtersForm.get('MPDocumentNumber')?.hasError(ValidationError.INVALID_MP_DOCUMENT_NUMBER)}">
                  <input matInput formControlName="MPDocumentNumber" placeholder="Filter by MP document number"
                    (blur)="onMPDocNumBlur($event)">
                  <button class="clear-button" *ngIf="filtersForm.get('MPDocumentNumber')?.value" matSuffix
                    mat-icon-button aria-label="Clear" (click)="onMPDocNumClear()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
                <p class="form-field-error paragraph-small-regular"
                  *ngIf="filtersForm.get('MPDocumentNumber')?.hasError(ValidationError.INVALID_MP_DOCUMENT_NUMBER)">
                  Fill in a valid MP document number
                </p>
              </div>
              <div class="form-field col-4">
                <p class="mb-1 paragraph-medium-regular"> Assigned PE name </p>
                <ng-select class="custom-ng-select--multiple " [items]="peDropdown" bindLabel="value" bindValue="id"
                  groupBy="groupBy" [multiple]="true" [closeOnSelect]="false" [selectableGroup]="true"
                  [selectableGroupAsModel]="false" appearance="outline" formControlName="purchaseExecutives"
                  [placeholder]="selectedPurchaseExecutivesLabel">
                  <ng-template ng-label-tmp let-item="item" let-index="index">
                  </ng-template>
                  <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                    <mat-checkbox [checked]="isEveryPurchaseExecutiveChecked"
                      [indeterminate]="!isEveryPurchaseExecutiveChecked && filtersForm.get('purchaseExecutives')!.value.length !== 0"
                      color="primary">Select
                      All</mat-checkbox>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <mat-checkbox [checked]="filtersForm.get('purchaseExecutives')!.value.includes(item.id)"
                      color="primary">{{item.value}}</mat-checkbox>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="d-flex row">
              <div class="form-field col-4">
                <p class="mb-1 paragraph-medium-regular"> RFQ Summary document status </p>
                <ng-select class="custom-ng-select--multiple " [items]="rfqStatusDropdown" bindLabel="value"
                  bindValue="id" groupBy="groupBy" [multiple]="true" [closeOnSelect]="false" [selectableGroup]="true"
                  [selectableGroupAsModel]="false" appearance="outline" formControlName="RFQStatus"
                  [placeholder]="selectedRFQStatusLabel">
                  <ng-template ng-label-tmp let-item="item" let-index="index">
                  </ng-template>
                  <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                    <mat-checkbox [checked]="isEveryRFQStatusChecked"
                      [indeterminate]="!isEveryRFQStatusChecked && filtersForm.get('RFQStatus')!.value.length !== 0"
                      color="primary">Select
                      All</mat-checkbox>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <mat-checkbox [checked]="filtersForm.get('RFQStatus')!.value.includes(item.id)"
                      color="primary">{{item.value}}</mat-checkbox>
                  </ng-template>
                </ng-select>
              </div>
              <div class="form-field pb-3 mt-1 col-4">
                <p class="mb-1 paragraph-medium-regular">RFQ Summary creation date range</p>
                <mat-form-field class="custom-form-field--date"
                  [ngClass]="{'has-error': filtersForm.get('startDate')?.hasError(ValidationError.CUSTOM_MISSING_START_END_DATE) || filtersForm.get('startDate')?.hasError(ValidationError.MAXIMUM_6_MONTHS)}">
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="startDate" placeholder="dd/mm/yyyy" (focus)="picker.open()">
                    <input matEndDate formControlName="endDate" placeholder="dd/mm/yyyy" (focus)="picker.open()">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <p class="form-field-error paragraph-small-regular"
                  *ngIf="filtersForm.get('startDate')?.hasError(ValidationError.CUSTOM_MISSING_START_END_DATE)">
                  Fill in a valid start and end date
                </p>
                <p class="form-field-error paragraph-small-regular"
                  *ngIf="filtersForm.get('startDate')?.hasError(ValidationError.MAXIMUM_6_MONTHS)">
                  Start date to end date cannot be more than 6 months
                </p>
              </div>
              <div class="form-field col-4" *ngIf="isUserPE">
                <p class="mb-1 paragraph-medium-regular"> Assigned RO name </p>
                <ng-select class="custom-ng-select--multiple" [items]="userDropdown" bindLabel="value" bindValue="id"
                  groupBy="groupBy" [multiple]="true" [closeOnSelect]="false" [selectableGroup]="true"
                  [selectableGroupAsModel]="false" appearance="outline" formControlName="requestingOfficer"
                  [placeholder]="selectedRequestingOfficerLabel">
                  <ng-template ng-label-tmp let-item="item" let-index="index">
                  </ng-template>
                  <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                    <mat-checkbox [checked]="isEveryRequestingOfficerChecked"
                      [indeterminate]="!isEveryRequestingOfficerChecked && filtersForm.get('requestingOfficer')!.value.length !== 0"
                      color="primary">Select
                      All</mat-checkbox>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <mat-checkbox [checked]="filtersForm.get('requestingOfficer')!.value.includes(item.id)"
                      color="primary">{{item.value}}</mat-checkbox>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
      <div class="section--report-columns mt-3">
        <mat-expansion-panel expanded="true" togglePosition="before">
          <mat-expansion-panel-header>
            <mat-panel-title> Report Columns</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="container pt-3">
            <div class="form-field">
              <p class="mb-2 paragraph-medium-regular">Columns To Display</p>
              <p class="form-field-error mt-3 mb-1 paragraph-small-regular"
                *ngIf="filtersForm.get('csvHeaderKeys')?.hasError(ValidationError.MINIMUM_ONE_CSV_HEADER)">
                Select at least one column to display
              </p>
            </div>
            <div class="form-field mt-4" formArrayName="csvHeaderKeys">
              <div class="grid-container">
                <mat-checkbox [checked]="isSelectAllColumnSelected()" [indeterminate]="isPartialSelection()"
                  (change)="toggleAllDisplayColumn($event)" color="primary">
                  <span class="paragraph-medium-regular">Select All</span>
                </mat-checkbox>
              </div>
              <div class="grid-container">
                <div *ngFor="let headerOption of RFQ_HEADER_KEYS; let i = index" class="grid-item">
                  <mat-checkbox [formControlName]="i" class="mb-2" (change)="onIndividualCheckboxChange()"
                    color="primary"><span class="paragraph-medium-regular">{{
                    RFQ_HEADER_MAPPING[headerOption] }}</span></mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </form>
  </app-layout>
</div>